import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChatListQuery } from "web_myplann/Api/Chat/useChatListQuery";
import type { ChatConversation } from "web_myplann/Chat/Types/chatConversation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const useChatListPage = () => {
	const navigate = useNavigate();
	const { data: items = [], isLoading } = useChatListQuery();
	const [query, setQuery] = useState("");

	const filtered = useMemo(() => {
		const normalized = query.trim().toLowerCase();
		if (!normalized) return items;
		return items.filter(
			(conversation) =>
				conversation.title.toLowerCase().includes(normalized) ||
				(conversation.participants ?? []).some((participant) =>
					participant.name.toLowerCase().includes(normalized),
				) ||
				(conversation.last_message?.content ?? "")
					.toLowerCase()
					.includes(normalized),
		);
	}, [items, query]);

	const openConversation = (conversation: ChatConversation) => {
		navigate(Routing.Chat.Detail.path(String(conversation.id)));
	};

	const openNewMessage = () => {
		navigate(Routing.Chat.Detail.path("new"));
	};

	return {
		items: filtered,
		isLoading,
		query,
		setQuery,
		searchActive: query.trim().length > 0,
		clearSearch: () => setQuery(""),
		openConversation,
		openNewMessage,
	};
};
